import styled from 'styled-components';
import Button from '@prisjakt/ui-button';

export const SwitchButton = styled(Button)`
  position: absolute;
  top: 40%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s;
  color: #fff;

  && {
    svg {
      path {
        fill: #fff;
      }
    }
  }

  &&:hover,
  &&:focus {
    background: rgba(0, 0, 0, 0.4);
  }
`;

export const Carousel = styled.div.attrs({ 'data-test': 'Carousel' })`
  &:hover {
    ${SwitchButton} {
      opacity: 1;
    }
  }
`;
